<h3>
  <slot />
</h3>

<style lang="scss">
  h3 {
    font-family: "burgess-regular-pro";
    font-weight: normal;
    font-size: 1.5625rem;
    line-height: 1.75rem;
    color: #0A2F54;
    margin: 0 0 12px;
  }

  @media (min-width: 588px) {
    h3 {
      margin-bottom: 16px;
    }
  }
</style>
